module.exports = __webpack_public_path__ + "img/win_2.0ee75939.png";